import {
  ATTR2PROP,
  widgetFromProp,
} from '../../facts/table-view';


require('./chat-viewer-node.component.scss');

export function ChatViewerNodeComponent($compile) {
  return {
    template: require('./chat-viewer-node.component.html'),
    restrict: 'AE',
    scope: {
      filter: '<',
      fact: '<',
      showHead: '<',
      openImage: '&',
      setFilterCut: '&'
    },
    controller: function($scope, $element, $sce, $window) {
      $scope.setSender = () => $scope.setFilterCut({
        dim: 'agent_dialog@sender:sender',
        val: $scope.message().sender
      });
      $scope.setChannel = () => $scope.setFilterCut({
        dim: 'agent_dialog@dialog_type:dialog_type',
        val: $scope.message().channel
      });
      $scope.setMembers = () => $scope.setFilterCut({
        dim: 'agent_dialog@members:members',
        val: $scope.message().members
      });
      $scope.setUser = () => $scope.setFilterCut({
        dim: 'agent_account@user_name:user_name',
        val: $scope.message().user
      });

      // sender:  ATTR2PROP['agent_dialog.sender']($scope.fact).val,
      // members: ATTR2PROP['agent_dialog.members']($scope.fact).val,

      $scope.message = () => ({
        isOut: $scope.fact['agent_dialog.direction'] === 'Outgoing',
        userName: $scope.fact['agent_account.full_name'] ?
          $scope.fact['agent_account.full_name'] : $scope.fact['agent_account.user_name'],
        user: $scope.fact['agent_account.user_name'],
        sender: $scope.fact['agent_dialog.sender'],
        date: ATTR2PROP['local_time']($scope.fact).val,
        members: $scope.fact['agent_dialog.members'],
        channel: $scope.fact['agent_dialog.dialog_type'],
      });
    },
    link: function(scope, element, attrs) {

      scope.$watch('fact', function(newVal, oldVal) {
        if (!scope.filter) return;
        const fact = newVal ? newVal : {};
        let widget = '<div class="widget-data widget-properties">';
        if (fact['agent_dialog.message_format'] === 'Call') {
          widget += '<i class="icon-bell"></i>' + gettext('Звонок');
        } else {
          widget += fact['text_data'] ? ATTR2PROP['text_data'](fact).sval : '';
          widget += fact['agent_attachedfile.data'] ? ATTR2PROP['agent_attachedfile.data'](fact).val : '';

          if (fact && fact.children) {
            widget += fact.children.map(ch => {
              ch['parentName'] = fact['agent_eventtype.name'];
              return ch['agent_attachedfile.data'] ?
                widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
            }).join('');
          }
        }
        widget += '</div>';
        element.find('.message-body').html(widget);

        widget = ATTR2PROP['agent_dialog.members'](fact).val;
        element.find('.members-info').html(widget);

        widget = ATTR2PROP['agent_dialog.sender'](fact).val;
        if (!widget.match('<sc-account')) widget += ',';
        element.find('.message-sender').html(widget);

        $compile(element.contents())(scope);
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/view/chat-viewer/chat-viewer-node.component.js